var _createClass = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\createClass.js");

var _classCallCheck = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\classCallCheck.js");

var _inherits = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\inherits.js");

var _possibleConstructorReturn = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\possibleConstructorReturn.js");

var _getPrototypeOf = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EventEmitter = require('events');

var InjectedConnection = /*#__PURE__*/function (_EventEmitter) {
  "use strict";

  _inherits(InjectedConnection, _EventEmitter);

  var _super = _createSuper(InjectedConnection);

  function InjectedConnection(_injected, options) {
    var _this;

    _classCallCheck(this, InjectedConnection);

    _this = _super.call(this);

    if (_injected) {
      setTimeout(function () {
        return _this.emit('error', new Error('Injected web3 provider is not currently supported'));
      }, 0);
    } else {
      setTimeout(function () {
        return _this.emit('error', new Error('No injected provider found'));
      }, 0);
    }

    return _this;
  }

  return _createClass(InjectedConnection);
}(EventEmitter);

module.exports = function (injected) {
  return function (options) {
    return new InjectedConnection(injected, options);
  };
};